// import React, { useState } from 'react';

// export function ExpandingCards({ data }) {
//   const [activeId, setActiveId] = useState(0);

//   const onHover = (id) => setActiveId(id);
//   const onLeave = () => setActiveId(0);

//   return (
//     <div className="expanding-card-container">
//       {
//         data.map(card => (
//           <a 
//             key={card.id}
//             href={card.link}
//             className={`panel ${activeId === card.id ? 'active' : ''}`}
//             onMouseEnter={() => onHover(card.id)}
//             onMouseLeave={onLeave}
//             style={{ 
//               display: 'block', 
//               backgroundImage: `url(${card.imageSrc})`,
//               textDecoration: 'none', // Optional: To remove underline from link
//               color: 'inherit' // Optional: To inherit text color from the parent element
//             }}>
//             <div>
//               <h3>{card.title}</h3>
//             </div>
//           </a>
//         ))
//       }
//     </div>
//   );
// }


import React, { useState } from 'react';
import { Link } from 'react-router-dom';

export function ExpandingCards({ data }) {
  const [activeId, setActiveId] = useState(0);

  const onHover = (id) => setActiveId(id);
  const onLeave = () => setActiveId(0);

  return (
    <div className="expanding-card-container">
      {
        data.map(card => (
          <Link
            key={card.id}
            to={card.link}
            className={`panel ${activeId === card.id ? 'active' : ''}`}
            onMouseEnter={() => onHover(card.id)}
            onMouseLeave={onLeave}
            style={{ 
              display: 'block', 
              backgroundImage: `url(${card.imageSrc})`,
              textDecoration: 'none',
              color: 'inherit'
            }}
          >
            <div>
              <h3>{card.title}</h3>
            </div>
          </Link>
        ))
      }
    </div>
  );
}